import React from 'react';
import { motion } from 'framer-motion';
import styles from './Contact.module.css';

const ContactInfo = () => {
  const contactDetails = [
    {
      icon: '📍',
      title: 'Location',
      content: 'Michigan, United States'
    },
    {
      icon: '📧',
      title: 'Email',
      content: 'sourenasan01@gmail.com'
    },
    {
      icon: '📱',
      title: 'Phone',
      content: '+1 (240) 651-9401'
    }
  ];

  return (
    <div className={styles.contactInfo}>
      <h3>Contact Information</h3>
      {contactDetails.map((detail, index) => (
        <motion.div
          key={detail.title}
          className={styles.infoItem}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          <span className={styles.infoIcon}>{detail.icon}</span>
          <div className={styles.infoContent}>
            <h4>{detail.title}</h4>
            <p>{detail.content}</p>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default ContactInfo; 